import { render } from "./BookDemo.vue?vue&type=template&id=556610ab"
import script from "./BookDemo.vue?vue&type=script&lang=js"
export * from "./BookDemo.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./BookDemo.vue?vue&type=style&index=0&id=556610ab&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__